import setup from './moduleSetup';

export default {
    name: 'customers',
    before: [],
    after: [],
    setup,
};
